module.exports = __webpack_public_path__ + "static/img/mask1.9c284a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mask1.png
// module id = huIK
// module chunks = 0